import { render, staticRenderFns } from "./IndexFilters.vue?vue&type=template&id=6f72da56&"
import script from "./IndexFilters.vue?vue&type=script&lang=js&"
export * from "./IndexFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports